import { pushEvent } from './pushEvent';

export function pushWciCompleteEvent(pnr, ref) {
  pushEvent({ event: 'wci_complete', data: { booking_reference: pnr, ref } });
}
